import React, { useEffect, useRef, useState } from 'react';
import { Form, Input } from 'components/ds';
import { useGetTemplate } from 'modules/account/configs/SchemaConfig';
import { ValidatorField } from 'components/ValidatorField';
import { StyledIcon } from './UserNameField.styles';
import { useUsername } from '../../hooks/useUsername';
import { FormInstance } from 'antd';

interface UserNameFieldProps {
  size?: 'large' | 'middle' | 'small';
  form?: FormInstance;
  isDisabled?: boolean;
}

const UserNameField: React.FC<UserNameFieldProps> = ({
                                                       size = 'large',
                                                       form,
                                                       isDisabled,
                                                       ...props
                                                     }) => {
  const { data: pageConfigUsername = {} } = useGetTemplate('username');
  const { formFields = [] } = pageConfigUsername;
  const { username, hasUsername } = useUsername();
  const [shouldApplyMask, setShouldApplyMask] = useState(false);
  const inputRef = useRef<any>(null);
  
  useEffect(() => {
    if (hasUsername && form && username) {
      setShouldApplyMask(true);
      
      setTimeout(() => {
        const maskedValue = inputRef.current?.input?.value;
        
        if (maskedValue) {
          form.setFieldsValue({ username: maskedValue });
        }
      }, 100);
    }
  }, [username, hasUsername, form, formFields]);
  
  return (
    <>
      {formFields.map((field: any) => {
        const fieldRules = [
          { required: true, message: 'Este campo é obrigatório' },
          { validator: (rule: any, value: any) => ValidatorField.validator(rule, value, field) },
          ...(field.rules || [])
        ];
        
        return (
          <Form.Item
            key={field.name}
            name={field.name}
            rules={fieldRules}
            initialValue={hasUsername ? username : undefined}
            {...props}
          >
            <Input
              ref={inputRef}
              key={shouldApplyMask ? 'masked' : 'unmasked'}
              type={field.type}
              placeholder={field.label || field.placeholder}
              mask={field.mask}
              size={size}
              prefix={<StyledIcon />}
              style={{ paddingLeft: 10 }}
              disabled={isDisabled}
              shouldApplyMask={shouldApplyMask}
            />
          </Form.Item>
        );
      })}
    </>
  );
};

export default UserNameField;
